<template>
  <a-spin :spinning="loading">
    <div class="l-form"
         :style="{'--login-first-color': loginSettings.loginFirstColor,
          '--login-text-color': loginSettings.loginTextColor,
          '--login-transparency': loginSettings.loginTransparency}">
      <video autoplay muted loop id="myVideo">
        <source :src="video" type="video/mp4">
      </video>
      <div id="videoContainer">
        &nbsp;
      </div>
      <a href="#" id="invisiblelink"></a>
      <div class="shape1"></div>
      <div class="shape2"></div>

      <div class="form">
        <img
          :src="logo"
          alt="" class="form__img">

        <form class="form__content" @submit.prevent="login">
          <h1 class="form__title">{{loginSettings.message}}</h1>

          <div class="form__div form__div-one">
            <div class="form__icon">
              <a-icon type="user"></a-icon>
            </div>

            <div class="form__div-input">
              <label for="" class="form__label">Usuario</label>
              <input type="text" class="form__input" v-model="username">
            </div>
          </div>

          <div class="form__div">
            <div class="form__icon">
              <a-icon type="lock" />
            </div>

            <div class="form__div-input">
              <label for="" class="form__label">Contraseña</label>
              <input type="password" class="form__input" v-model="password">
            </div>
          </div>
          <a href="#/password_recovery" class="form__forgot">Olvidé mi contraseña</a>

          <input type="submit" class="form__button" value="Iniciar Sesión">
<!--
          <div class="form__social">
            <span class="form__social-text">Our login with</span>

            <a href="#" class="form__social-icon"><i class='bx bxl-facebook'></i></a>
            <a href="#" class="form__social-icon"><i class='bx bxl-google'></i></a>
            <a href="#" class="form__social-icon"><i class='bx bxl-instagram'></i></a>
          </div>
-->
        </form>
      </div>
    </div>
  </a-spin>
</template>
<script>
import UserUtil from '@/util/UserUtil'

export default {
  data () {
    return {
      username: '',
      password: '',
      loading: false
    }
  },
  mounted () {
    /* ===== FOCUS ===== */
    const inputs = document.querySelectorAll('.form__input')

    /* === Add focus === */
    function addfocus () {
      let parent = this.parentNode.parentNode
      parent.classList.add('focus')
    }

    /* === Remove focus === */
    function remfocus () {
      let parent = this.parentNode.parentNode
      if (this.value === '') {
        parent.classList.remove('focus')
      }
    }

    /* === To call function=== */
    inputs.forEach(input => {
      input.addEventListener('focus', addfocus)
      input.addEventListener('blur', remfocus)
    })

    inputs.forEach(input => {
      input.parentNode.parentNode.classList.add('focus')
    })
  },
  methods: {
    login (e) {
      e.preventDefault()
      this.loading = true
      UserUtil.login(this.username, this.password, (response) => {
        if (this.$store.state.lastRoute === null || this.$store.state.lastRoute.name === '' || this.$store.state.lastRoute.name === null) {
          this.$router.push({path: this.$store.state.userInfo.menu[0].path})
        } else {
          this.$router.push({
            path: this.$store.state.lastRoute.path
          })
        }
        this.loading = false
      }, (error) => {
        this.loading = false
        this.$notification.error({
          message: 'Error',
          description:
            'Usuario y/o contraseña incorrecta.'
        })
      })
    }
  },
  computed: {
    loginSettings () {
      return this.$store.state.appSettings.login || {
        video: 'video steel.mp4',
        message: 'SteelOBPO',
        loginFirstColor: '#AC2FCD',
        loginTextColor: '#FFFFFF',
        loginTransparency: 0.5
      }
    },
    video () {
      return this.loginSettings.video
        ? require(`@/customization/SteelOApp/pages/Login/Assets/Video/${this.loginSettings.video}`)
        : require(`@/customization/SteelOApp/pages/Login/Assets/Video/video steel.mp4`)
    },
    logo () {
      return this.loginSettings.video
        ? require(`@/customization/SteelOApp/pages/Login/Assets/Img/${this.loginSettings.logo}`)
        : require(`@/customization/SteelOApp/pages/Login/Assets/Img/loginlogo.svg`)
    }
  }
}
</script>
<style>
#videoContainer {
  background: rgba(0, 0, 0, var(--login-transparency));
}

#videoContainer, #myVideo {
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: -1;
}

/*=== Fuente y tipografia ===*/
:root {
  --body-font: 'Roboto', sans-serif;
  --big-font-size: 2rem;
  --normal-font-size: 0.938rem;
  --smaller-font-size: 0.875rem;
}

@media screen and (min-width: 768px) {
  :root {
    --big-font-size: 2.5rem;
    --normal-font-size: 1rem;
  }
}

/*===== BASE =====*/
*, ::before, ::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  /*font-family: var(--body-font);*/
  /*color: var(--login-first-color);*/
}

h1 {
  margin: 0;
}

a {
  text-decoration: none;
}

img {
  max-width: 100%;
  height: auto;
}

/*===== FORM =====*/
.l-form {
  position: relative;
  height: 100vh;
  overflow: hidden;
}

/*=== Shapes ===*/
.shape1,
.shape2 {
  position: absolute;
  width: 200px;
  height: 200px;
  border-radius: 50%;
}

.shape1 {
  top: -7rem;
  left: -3.5rem;
  background: linear-gradient(180deg, var(--login-first-color) 0%, rgba(196, 196, 196, 0) 100%);
}

.shape2 {
  bottom: -6rem;
  right: -5.5rem;
  background: linear-gradient(180deg, var(--login-first-color) 0%, rgba(196, 196, 196, 0) 100%);
  transform: rotate(180deg);
}

/*=== Form ===*/
.form {
  height: 100vh;
  display: grid;
  justify-content: center;
  align-items: center;
  padding: 0 1rem;
}

.form__content {
  width: 290px;
}

.form__img {
  display: none;
}

.form__title {
  font-size: var(--big-font-size);
  font-weight: 500;
  margin-bottom: 2rem;
  color: var(--login-text-color);
}

.form__div {
  position: relative;
  display: grid;
  grid-template-columns: 7% 93%;
  margin-bottom: 1rem;
  padding: .25rem 0;
  border-bottom: 1px solid var(--login-text-color);
}

/*=== Div focus ===*/
.form__div.focus {
  /*border-bottom: 1px solid var(--login-first-color);*/
}

.form__div-one {
  margin-bottom: 3rem;
}

.form__icon {
  font-size: 1.5rem;
  color: var(--login-text-color);
  transition: .3s;
}

/*=== Icon focus ===*/
.form__div.focus .form__icon {
  /*color: var(--login-first-color);*/
}

.form__label {
  display: block;
  position: absolute;
  left: .75rem;
  top: .25rem;
  font-size: var(--normal-font-size);
  color: var(--login-text-color);
  transition: .3s;
}

/*=== Label focus ===*/
.form__div.focus .form__label {
  top: -1.5rem;
  font-size: .875rem;
}

.form__div-input {
  position: relative;
}

.form__input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  background: none;
  padding: .5rem .75rem;
  font-size: 1.2rem;
  color: var(--login-text-color);
  transition: .3s;
}

.form__forgot {
  display: block;
  text-align: right;
  margin-bottom: 2rem;
  font-size: var(--normal-font-size);
  color: var(--login-text-color);
  font-weight: 500;
  transition: 0.5;
}

.form__forgot:hover {
  color: var(--login-text-color);
  text-decoration: underline;
  transition: .5s;
}

.form__button {
  width: 100%;
  padding: 1rem;
  font-size: var(--normal-font-size);
  outline: none;
  border: none;
  margin-bottom: 3rem;
  background-color: var(--login-first-color);
  color: #fff;
  border-radius: .5rem;
  cursor: pointer;
  transition: .3s;
}

.form__button:hover {
  box-shadow: 0px 15px 36px rgba(0, 0, 0, .15);
}

/*=== Form social===*/
.form__social {
  text-align: center;
}

.form__social-text {
  display: block;
  font-size: var(--normal-font-size);
  margin-bottom: 1rem;
}

.form__social-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  margin-right: 1rem;
  padding: .5rem;
  background-color: var(--login-text-color);
  color: #fff;
  font-size: 1.25rem;
  border-radius: 50%;
}

.form__social-icon:hover {
  background-color: var(--login-first-color);
}

/* Change Autocomplete styles in Chrome*/
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  /*border: 1px solid green;*/
  -webkit-text-fill-color: var(--login-text-color);
  -webkit-box-shadow: 0 0 0 1000px transparent inset;
  transition: background-color 5000s ease-in-out 0s;
}


/*===== MEDIA QUERIS =====*/
@media screen and (min-width: 968px) {
  .shape1 {
    width: 400px;
    height: 400px;
    top: -11rem;
    left: -6.5rem;
  }

  .shape2 {
    width: 300px;
    height: 300px;
    right: -6.5rem;
  }

  .form {
    grid-template-columns: 1.5fr 1fr;
    padding: 0 2rem;
  }

  .form__content {
    width: 320px;
  }

  .form__img {
    display: block;
    width: 700px;
    justify-self: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/customization/SteelOApp/pages/Login/Login.vue